import React from "react";
import { Button, PageTitle, SmartTooltip, TableAdv } from "../../../components";
import { v4 as uuidv4 } from "uuid";
import { dateFormator } from "../../../utils";

const BankingAccordion = ({ uiid, activities }) => {
  console.log({ activities });
  const rows = activities?.map((activity) => ({
    id: activity?._id,
    date: dateFormator(activity?.date),
    transactionDetails: activity?.description,
    journalId: uiid ? `JR-${String(uiid).padStart(2, "0")}` : "-",
    debit: activity?.debit ? activity?.debit : "-",
    credit: activity?.credit ? activity?.credit : "-",
    balance: activity?.balance ? activity?.balance : "0.00",
    modifiedOn: dateFormator(activity?.performedOn),
    updatedBy: activity?.performedBy?.firstName + " " + activity?.performedBy?.lastName,
  }))?.reverse() || [];

  const columns = [
    {
      key: "date",
      label: "Date",
      render: (row) => (
        <SmartTooltip
          description={row?.date}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div>{row?.date}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "transactionDetails",
      label: "Transaction Details",
      render: (row) => (
        <SmartTooltip
          description={row?.transactionDetails}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div>{row?.transactionDetails}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "journalId",
      label: "Journal ID",
      render: (row) => (
        <SmartTooltip
          description={row?.journalId}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div>{row?.journalId}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "debit",
      label: "Debit",

      render: (row) => (
        <SmartTooltip
          description={row?.debit}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div>{row?.debit}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "credit",
      label: "Credit",

      render: (row) => (
        <SmartTooltip
          description={row?.credit}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div>{row?.credit}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "balance",
      label: "Balance",

      render: (row) => (
        <SmartTooltip
          description={row?.balance}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div>{row?.balance}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "modifiedOn",
      label: "Modified On",

      render: (row) => (
        <SmartTooltip
          description={row?.modifiedOn}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div>{row?.modifiedOn}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "updatedBy",
      label: "Updated By",
    },
  ];
  return (
    <div className="p-5">
      <PageTitle title="Activity" className="mb-2 text-primary" />
      <TableAdv
        tableId={"banking_bankingaccordion"}
        color="amber"
        columns={columns}
        rows={rows}
        hideToolBar
      />
    </div>
  );
};

export default BankingAccordion;
